import React, { ReactNode } from 'react';
import { checkSICCodeExistence } from '@insurancemenu/imenu-components-lib/dist/utils/forms/sic';

const DDNJ_DENTAL_INELIGIBLE_SIC_CODES = new Set(['7389', '8021', '8811', '8999']);

const DDNJ_DENTAL_INELIGIBLE_SIC_RANGES: Array<[number, number]> = [
  [761, 783],
  [7361, 7363],
  [8200, 8299],
  [8600, 8699],
  [9000, 9720],
  [9722, 9998],
];

const isSICCodeIneligibleForDental = (value: string): boolean => {
  if (DDNJ_DENTAL_INELIGIBLE_SIC_CODES.has(value)) return true;

  const sicCode = Number(value);
  return DDNJ_DENTAL_INELIGIBLE_SIC_RANGES.some(([min, max]) => sicCode >= min && sicCode <= max);
};

/**
 * Non-blocking warning copy for the SIC `Alert`, or `null` when there is no warning.
 *
 * Hard-block codes and warning prefixes do not overlap, so invalid codes only show the field message.
 * If a SIC ever matches both an error rule and a warning rule, add an early guard here (e.g. return `null` for those
 * codes) so users do not see an error and the warning note at the same time.
 */
export function ddnjSICWarningMessage(value: string): ReactNode {
  if (value.length !== 4 || !checkSICCodeExistence(value)) return null;

  if (isSICCodeIneligibleForDental(value)) {
    return <>Dental offices are excluded from purchasing a group dental policy.</>;
  }

  if (value === '8042') {
    return <>Optometrist offices are excluded from purchasing a vision policy.</>;
  }

  return null;
}
